<template>
    <div :class="['campaign-background', { 'is-moved': isMoved }]" />
</template>

<script>
export default {
    name: 'CampaignBackground',
    props: {
        isMoved: {
            type: Boolean,
            default: false
        },
        logoInFront: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/mixin';
    @import 'src/assets/scss/_variables/screen';

    .campaign-background {
        background: transparent url("~@/assets/images/campaign_bg_max.jpg") no-repeat center top;
        background-size: cover;
        position: fixed;
        z-index: 1;
        // transform: translateX(0);
        // transition: transform .3s;
        // transition-delay: .6s;
        // @include size(100%);
        left: 0;
        top: 0;
        right: 800px;
        bottom: 0;
/*
        &-logo {
            position: fixed;
            bottom: 0;
            max-width: 100%;
            background: url("~@/assets/images/corner_logo.svg") no-repeat 7px 100%;
            background-size: contain;
            right: 0;
            transition: transform .3s;
            transition-delay: .6s;
            @include size(478px, 181px);
            //@include size(633px, 181px);

        }

        &.is-moved & {
            &-logo {
                transform: translateX(-807px);
            }
        }*/

       /* @media (min-width: $screen-wide-desktop) {
            background-position-x: 0;
        }
        @media (max-width: $screen-wide-desktop) {
            transform: translateX(-20%);
        }
        @media (max-width: $screen-desktop) {
            transform: translateX(-40%);
        }
        @media (max-width: $screen-small-tablet) {
            display: none;
        }*/
    /*
        @media (min-width: $screen-tablet) {
            background-image: url("~@/assets/images/campaign_bg_max.jpg");
            background-position-x: 60%;
            z-index: -1;

            //&.is-moved {
            //    transform: translateX(-180px);
            // }

            &.is-moved & {

                &-logo {
                    transform: translateX(-807px);
                }
            }
        }

        @media (min-width: $screen-page) {
            background-position: 50% 0;


            &.is-moved & {
                &-logo {
                    transform: translateX(-807px);
                }
            }
        }

        @media (min-width: $screen-laptop) {
            background-image: url("~@/assets/images/campaign_bg_max.jpg");
            background-position: 50% 26%;

            &-logo {
                width: 633px;
            }
        }

        @media (min-width: $screen-desktop) {
            background-position: 100% 0;

            &.is-moved & {
                &-logo {
                    transform: translateX(-807px);
                }
            }
        }*/
}
</style>
